import {makeStyles} from "@material-ui/core/styles";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "@mui/material/IconButton";

const useStyles = makeStyles(theme => ({
    modal: {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.6)",
        zIndex:"100"
    },
    modalMain: {
        position: "fixed",
        background: "#FFF",
        display:"flex",
        flexDirection:"column",
        backgroundColor: "#fff",
        borderRadius: "20px",
        width:"400px",
        boxShadow: "5px 10px 18px #888888",
        padding:"16px",
        height: "auto",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    }
}))

function CustomModal(props) {
    const classes = useStyles();
    const { show, children, handleClose} = props;
    return (
        <div className={classes.modal} style={{display: show ? "block" : "none"}}>
            <section className={classes.modalMain}>
                <IconButton aria-label="Cerrar" style={{alignSelf:"end"}} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                {children}
            </section>
        </div>
    );
}

export default CustomModal;